// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1iEeq","buttons":"PendingPaymentAlert_buttons__2Tu-F"};